// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Vba-z","narrowOptionButtons":"Wba-z","noOptions":"Xba-z"};